<template>
    <div ref="previewContainer">
        <div v-if="showPreview" class="preview-bar" :style="toolBarStyle">
            <div class="close" @click="onClosePreview"></div>
            <div class="page">
                {{ `${curPreviewIndex + 1}/${previewList.length}` }}
            </div>
            <div v-if="!noticeFormPreview" class="delete" @click="onDeleteFile"></div>
        </div>
        <previewer
            ref="previewer"
            :list="previewList"
            :options="previewerOptions"
            @on-close="onPreviewerClose"
            @on-index-change="onPreviewerIndexChange"
        ></previewer>
    </div>
</template>
<script>
import '@ks/sharp-comp-previewer/lib/themes/default/index.css';
import { getUrlParam } from '../../../utils/url';
import Previewer from './photo-swipper.vue';
import { inYoda, inIm } from '../../../utils/bridge/ui';
import { useBridge } from '../../../utils/bridge/common';

export default {
    name: 'img-previewer',
    components: {
        Previewer,
    },
    props: {
        previewList: {
            type: Array,
            default: () => [],
        },
        noticeFormPreview: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            // 预览图
            showPreview: false,
            previewImgSrc: '',
            previewerOptions: {
                loop: false,
                closeEl: false,
                errorMsg: '<div class="pswp__error-msg">图片加载失败，请等待上传完成再预览</div>',
            },
            curPreviewIndex: 0,
            toolBarStyle: {
                top: 0,
                paddingRight: getUrlParam('isPc') ? '40px' : '19px',
            },
        };
    },
    async created() {
        if (!inYoda || inIm) {
            const params = {};
            const nameSpaceApi = 'webview.getDeviceInfo';
            const res = await useBridge(nameSpaceApi, params);
            this.setToolbarStyle(res.data);
        }
    },
    methods: {
        setToolbarStyle(data) {
            if (data && data.titleBarHeight && data.statusBarHeight) {
                let r;
                if (data.devicePixelRatio) {
                    r = data.devicePixelRatio;
                } else {
                    r = window.devicePixelRatio || 2;
                }
                // titleBarHeight 导航栏高度
                // statusBarHeight 状态栏高度
                // const navHeight = `${data.titleBarHeight / r}px`;
                const statusHeight = `${data.statusBarHeight / r}px`;
                this.toolBarStyle.top = statusHeight;
            }
        },
        onClosePreview() {
            this.$refs.previewer.close();
        },
        onDeleteFile() {
            this.onClosePreview();
            this.$emit('on-delete-file', this.curPreviewIndex);
        },
        onPreviewerClose() {
            this.showPreview = false;
            this.$emit('on-previewer-close');
        },
        onPreviewerIndexChange(index) {
            this.curPreviewIndex = index.currentIndex;
            this.$emit('on-previewer-index-change', index);
        },
        async showIndex(index) {
            // const $contents = document.getElementsByClassName('content');
            // if ($contents && $contents.length) {
            //     // .style.overflow= ‘visible’
            //     $contents.forEach(el => {
            //         el && (el.style.overflow = 'visible');
            //     })
            // }
            this.showPreview = true;
            this.curPreviewIndex = index;
            this.$refs.previewer.show(this.curPreviewIndex);
            await this.$nextTick();
            const el = this.$refs.previewContainer;
            document.body.appendChild(el);
        },
    },

};
</script>
<style lang="less" scoped>
.preview-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    z-index: 2000;
    padding: 5px 19px 2px 11px;
    box-sizing: border-box;
    .close {
        width: 40px;
        height: 40px;
        background-image: url('../../../../assets/images/back.svg');
    }
    .delete {
        width: 24px;
        height: 24px;
        background-image: url('../../../../assets/images/delete.svg');
    }
    .page {
        color: #FFF;
        font-size: 16px;
        line-height: 24px;
    }
}
</style>